
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/5705871e133a048fcd13b20b6e4d74bd/26d8c27b87decb516fa51c337abf97bb.jpeg" 
                alt="ESAPCOR Logo" 
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="text-white/80 leading-relaxed mb-6">
              ESAPCor Corporation - Công ty Giải pháp Công nghệ. Cung cấp các giải pháp về số hóa doanh nghiệp, phần mềm quản lý ERP, tự động hóa sản xuất và hỗ trợ giáo dục.
            </p>
            <div className="flex gap-3">
              <a href="https://esapcor.vn/website/social/facebook" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://esapcor.vn/website/social/linkedin" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="https://esapcor.vn/website/social/youtube" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Liên kết nhanh</h4>
            <ul className="space-y-3">
              <li>
                <a href="#introduction" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Giới thiệu
                </a>
              </li>
              <li>
                <a href="#quiz-section" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Trắc nghiệm
                </a>
              </li>
              <li>
                <a href="#suggestions-section" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Hướng dẫn
                </a>
              </li>
              <li>
                <a href="#contact-section" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Liên hệ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Dịch vụ</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://esapcor.vn/our-services" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Tư vấn chuyển đổi số
                </a>
              </li>
              <li>
                <a href="https://esapcor.vn/our-services" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Phần mềm quản lý ERP
                </a>
              </li>
              <li>
                <a href="https://esapcor.vn/our-services" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Tự động hóa sản xuất
                </a>
              </li>
              <li>
                <a href="https://esapcor.vn/our-services" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Phần mềm hỗ trợ giáo dục
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Thông tin liên hệ</h4>
            <ul className="space-y-4">
              <li className="flex gap-3 items-start">
                <i className="ri-building-line text-xl text-teal-400 mt-1"></i>
                <div>
                  <p className="text-white/80">Công ty TNHH ESAPCOR</p>
                  <p className="text-white/60 text-sm">MST: 3603821139</p>
                </div>
              </li>
              <li className="flex gap-3 items-start">
                <i className="ri-mail-line text-xl text-teal-400 mt-1"></i>
                <div>
                  <a href="mailto:info@esapcor.vn" className="text-white/80 hover:text-white transition-colors">
                    info@esapcor.vn
                  </a>
                </div>
              </li>
              <li className="flex gap-3 items-start">
                <i className="ri-phone-line text-xl text-teal-400 mt-1"></i>
                <div>
                  <a href="tel:+84902730008" className="text-white/80 hover:text-white transition-colors">
                    +84 (902) 730 008
                  </a>
                  <br />
                  <a href="tel:+84902768879" className="text-white/80 hover:text-white transition-colors">
                    +84 (902) 768 879
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {currentYear} ESAPCor Corporation. Bản quyền thuộc về Công ty TNHH ESAPCOR.
            </p>
            <div className="flex gap-6">
              <a href="https://esapcor.vn/privacy" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">
                Chính sách bảo mật
              </a>
              <a href="https://esapcor.vn/contactus" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">
                Liên hệ
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
